import { Box, Drawer, Typography } from '@mui/material';
import type { IngestedEventSample } from '@weft/types';
import { isNotEmptyObject, isNullOrUndefined, isObject } from '@weft/utils';
import { formatDate } from 'apps/app/src/utils/date';

type EventDataDrawerProps = {
  dataDrawerOpen: boolean,
  closeDataDrawer: () => void,
  event?: IngestedEventSample,
};

export const EventDataDrawer: React.FC<EventDataDrawerProps> = ({ dataDrawerOpen, closeDataDrawer, event }) => {
  if (isNullOrUndefined(event)) {
    return null;
  }

  return (
    <Drawer
      anchor="right"
      PaperProps={{
        className: 'max-w-[400px] py-10 px-7 gap-y-7',
      }}
      slotProps={{
        backdrop: {
          invisible: true,
        },
      }}
      open={dataDrawerOpen}
      onClose={closeDataDrawer}
    >
      <Typography variant="h6">{event.name}</Typography>
      <Typography variant="subtitle2">{formatDate(event.timestamp)}</Typography>
      {isNotEmptyObject(event.data) && (
        <Box
          component="pre"
          sx={{
            backgroundColor: 'grey.200',
            padding: 1,
            borderRadius: 1,
            overflowX: 'auto',
          }}
        >
          <Typography component="code">
            {isObject(event.data) ? formatJson(event.data) : ''}
          </Typography>
        </Box>
      )}
    </Drawer>
  );
};

function formatJson(json: Record<string, unknown>) {
  const NEW_LINE = '\n';
  const TAB = '\t';
  
  const entries = Object.entries(json)
    .map(([key, value]) => `${TAB + key}: ${JSON.stringify(value)},`)
    .join(NEW_LINE);

  return `{${NEW_LINE + entries + NEW_LINE}}`;
}